import noUiSlider from 'nouislider'

export { noUiSlider }
